import gql from 'graphql-tag';

export const RecentQuickSearchQuery = gql`
	query confluence_recentQuickSearch(
		$cloudId: ID!
		$contentItemsLimit: Int!
		$spaceLimit: Int!
		$objectTypes: [ActivitiesObjectType!]
		$workedOnAPIEnabled: Boolean!
	) {
		activities {
			myActivities {
				viewed(
					filters: [
						{
							type: AND
							arguments: { products: [CONFLUENCE], objectTypes: $objectTypes, cloudIds: [$cloudId] }
						}
					]
					first: $contentItemsLimit
				) @skip(if: $workedOnAPIEnabled) {
					edges {
						node {
							id
							object {
								id
								content {
									id
									title
									links {
										webui
									}
									type
									space {
										id
										name
									}
									status
								}
							}
						}
					}
				}
				workedOn(
					filters: [
						{
							type: AND
							arguments: { products: [CONFLUENCE], objectTypes: $objectTypes, cloudIds: [$cloudId] }
						}
					]
					first: $contentItemsLimit
				) @include(if: $workedOnAPIEnabled) {
					edges {
						node {
							id
							object {
								id
								content {
									id
									title
									links {
										webui
									}
									type
									space {
										id
										name
									}
									status
								}
							}
						}
					}
				}
			}
		}
		myVisitedSpaces(limit: $spaceLimit) {
			nodes {
				spaces {
					id
					key
					name
					icon {
						path
					}
					links {
						webui
					}
				}
			}
		}
	}
`;
